<template>
  <div class="PassengerFields">
    <div
      v-for="field of visibleFields"
      :key="field.label"
      class="PassengerFields-field"
    >
      <span class="PassengerFields-fieldLabel">{{ field.label }}</span>
      <span class="PassengerFields-fieldValue">{{ field.value }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { PassengerFieldsProps } from './PassengerFields.model';

const props = defineProps<PassengerFieldsProps>();

const visibleFields = computed(() => (props.showEmpty ? props.fields : props.fields.filter((field) => field.value)));
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .PassengerFields {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: vars.$dimensions-d-5;

    &-field {
      display: flex;
      flex-direction: column;
      gap: vars.$dimensions-d-2;
    }

    &-fieldLabel {
      color: vars.$atoms-input-static-label-color;
      @include text.text('xs');
      font-weight: vars.$typography-weight-strong;
    }

    &-fieldValue {
      color: vars.$atoms-input-text-color;
      @include text.text('sm');
    }
  }
}
</style>
